<template>
  <a :href="href" target="_blank" :class="{ inline: inline }">
    <icon link type="external-link"></icon>
    <span>
      <slot></slot>
    </span>
  </a>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  components: {
    Icon
  },
  name: 'External-Link',
  props: {
    href: {
      required: true,
      type: String
    },
    inline: {
      required: false,
      type: Boolean
    }
  }
}
</script>

<style lang="postcss" scoped>
a {
  display: inline-block;
  text-decoration: none;

  & > div > svg {
    margin-right: 5px;
  }

  & span {
    margin-left: 7px;
    text-decoration: none;

    &:visited,
    &:hover,
    &:focus {
     color: var(--color-shakespeare);
     text-decoration: underline;
    }
  }
}

.inline {
  display: inline-flex;
  padding-left: 5px;

  &  > div > svg {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExternalLink.vue